module.exports = __webpack_public_path__ + "static/media/SummaryCh6_A01378565.f2ada74d.pdf";